// Local translations
export const T = {
  en_GB: {
    // JWT Token Section
    devJwtToken: "Development JWT Token",
    devJwtTokenDescription:
      "Use this token for testing the API. Contains your user ID and tenant ID (signed and secure).",
    refresh: "Refresh",
    copied: "Copied!",
    copyJwtToken: "Copy JWT Token",
    expires: "Expires:",
    userId: "User ID",
    email: "Email",
    tenantId: "Tenant ID",
    tenantSlug: "Tenant Slug",
    usage: "Usage:",
    authorizationBearer: "Authorization: Bearer {token}",
    failedToGenerateToken: "Failed to generate token. Please try refreshing.",
    // API Keys Section
    apiKeysTitle: "API Keys",
    apiKeysDescription: "Long-lived API keys for production integrations",
    createApiKey: "Create API Key",
  },
  nb_NO: {
    // JWT Token Section
    devJwtToken: "Utviklings-JWT-token",
    devJwtTokenDescription:
      "Bruk dette tokenet for å teste API. Inneholder bruker-ID og tenant-ID (signert og sikkert).",
    refresh: "Oppdater",
    copied: "Kopiert!",
    copyJwtToken: "Kopier JWT-token",
    expires: "Utløper:",
    userId: "Bruker-ID",
    email: "E-post",
    tenantId: "Tenant-ID",
    tenantSlug: "Tenant-slug",
    usage: "Bruk:",
    authorizationBearer: "Authorization: Bearer {token}",
    failedToGenerateToken: "Kunne ikke generere token. Prøv å oppdatere.",
    // API Keys Section
    apiKeysTitle: "API-nøkler",
    apiKeysDescription: "Langvarige API-nøkler for produksjonsintegrasjoner",
    createApiKey: "Opprett API-nøkkel",
  },
} as const;
